import * as Yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';
import { PARTY_TYPE_ENUM, SUBJECT_TYPE_ENUM } from 'app/shared/enumeration/enums';
import { defaultAddressValidation } from 'app/shared/address-input/model/address.schema';

export const partyValidationSchema = Yup.object({
  partyType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  person: Yup.object()
    .nullable()
    .notRequired()
    .when('subjectType', (subjectType, schema) => {
      if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
        return Yup.object({
          oib: Yup.string()
            .required(messages.MANDATORY_FIELD)
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .min(11, messages.OIB_MIN_MAX_LENGTH)
            .max(11, messages.OIB_MIN_MAX_LENGTH),
          firstName: Yup.string().required(messages.MANDATORY_FIELD),
          lastName: Yup.string().required(messages.MANDATORY_FIELD),
        });
      } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          firstName: Yup.string().notRequired(),
          lastName: Yup.string().notRequired(),
        }).notRequired();
      }
    }),
  legalEntity: Yup.object().when('subjectType', (subjectType, schema) => {
    if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
      return Yup.object({
        oib: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .min(11, messages.OIB_MIN_MAX_LENGTH)
          .max(11, messages.OIB_MIN_MAX_LENGTH),
        mb: Yup.string().notRequired(),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      });
    } else if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.FIZICKA_OSOBA) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        companyName: Yup.string().notRequired(),
      }).notRequired();
    } else if (
      subjectType &&
      subjectType[0] &&
      subjectType[0][0] &&
      (subjectType[0][0].id === SUBJECT_TYPE_ENUM.OBRT ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST ||
        subjectType[0][0].id === SUBJECT_TYPE_ENUM.OPG)
    ) {
      return Yup.object({
        oib: Yup.string().notRequired(),
        mb: Yup.string()
          .required(messages.MANDATORY_FIELD)
          .matches(/^\d+$/, messages.ONLY_DIGITS)
          .max(11, messages.MB_MAX_LENGTH),
        companyName: Yup.string().required(messages.MANDATORY_FIELD),
      }).notRequired();
    }
  }),
  partyAddress: defaultAddressValidation,
  email: Yup.string().email('Neispravan format').notRequired(),
  parties: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === PARTY_TYPE_ENUM.OPUNOMOCENIK_STRANKE) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }

    return Yup.array().notRequired();
  }),
  procurationType: Yup.object().when('partyType', (partyType, schema) => {
    if (partyType && partyType[0] && partyType[0][0] && partyType[0][0].id === PARTY_TYPE_ENUM.OPUNOMOCENIK_STRANKE) {
      return Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD);
    }

    return Yup.array().notRequired();
  }),
});

export const partyCaseUuidToCopyFromSchema = Yup.object({
  caseUuidToCopyFrom: Yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
});

export const partiesDataSchema = Yup.object({
  partyNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  partyFileInsight: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
});
